import $ from 'jquery';

$(document).ready(function() {
  const $openers = $('a[data-modal]');
  const $modal = $('.e-modal');

  //
  $openers.each(function() {
    const $thisOpener = $(this);
    const modal = $thisOpener.attr('data-modal');
    const $modal = $(`.e-modal[data-modal=${modal}]`);

    $thisOpener.on('click', (event) => {
      event.preventDefault();
      $modal.addClass('is-visible');
    });

  });

  //
  $modal.each(function() {
    const $thisModal = $(this);

    $thisModal.find('.js-modal-close, .modal-close, .modal-overlay').on('click', (event) => {
      event.preventDefault();
      $thisModal.removeClass('is-visible');
    });
  });

});



// WEBPACK FOOTER //
// ./app/ui/elements/modal/index.js